<template>
<div
  v-if="realMobile"
  class="select-date-duration"
>
  <span
    class="btn-duration"
    v-if="realMobile"
    @click="calendarShow = true"
    :class="{'no-select': isNoDate }"
  >
    {{calendarText}}
  </span>
  <van-calendar
    v-model="calendarShow"
    type="range"
    :default-date="defaultDate"
    :color="themeColor"
    :min-date="minDate"
    class="van-calendar-el"
    @confirm="calendarConfirm"
  />
</div>
</template>

<script>
import { parseTime } from '@/utils/index'
import  { mapGetters } from 'vuex';
export default {
  name: 'selectDateDuration',
  props: {
    value: {
    }
  },
  data() {
    let _this = this;
    return {
      calendarShow: false,
      pickerTime: _this.value || [],
      minDate: new Date(2020, 0, 1),
      themeColor: '#FE5924'
    };
  },
  watch: {
    value(newValue){
      this.pickerTime = newValue;
    }
  },
  computed: {
    ...mapGetters(['realMobile']),
    isNoDate(){
      if(!this.pickerTime || !this.pickerTime.length){
        return true;
      }else {
        return false;
      }
    },
    calendarText(){
      if(!this.pickerTime || !this.pickerTime.length){
        return '请选择日期';
      }else if(this.pickerTime && this.pickerTime.length == 2){
        if((typeof this.pickerTime[0]) == 'object'){
          let start = parseTime(this.pickerTime[0]).split(' ')[0];
          let end = parseTime(this.pickerTime[1]).split(' ')[0];
          return start + '/' + end;
        }else {
          let start = this.pickerTime[0].split(' ')[0];
          let end = this.pickerTime[1].split(' ')[0];
          return start + '/' + end;
        }
      }
    },
    defaultDate(){
      if(this.pickerTime && this.pickerTime.length == 2){
        return [new Date(this.pickerTime[0]),new Date(this.pickerTime[1])];
      }else {
        return [];
      }
    }
  },
  methods: {
    calendarConfirm(date){
      this.pickerTime = [];
      this.pickerTime[0] = parseTime(date[0]);
      this.pickerTime[1] = parseTime(date[1]);
      this.calendarShow = false;
      this.$emit('input',this.pickerTime);
    },
  }
};
</script>

<style lang="scss" scoped>
.select-date-duration {
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 10px;
  width: 100%;

  .btn-duration {
    display: block;
    width: 100%;
    height: 40px;
    line-height: 40px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding: 0 10px;
    overflow: hidden;
    word-break:  break-all;
    &.no-select {
      color: #C1C4CB;
    }
  }
  .van-calendar-el {

  }
}
</style>
